import * as React from 'react';
import { cn } from '../../lib/cn';

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: React.ReactNode;
  description?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}

export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center rounded-lg border border-dashed border-border bg-card px-6 py-14 text-center',
        className
      )}
    >
      {icon && (
        <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-muted text-muted-foreground [&_svg]:h-6 [&_svg]:w-6">
          {icon}
        </div>
      )}
      <h3 className="text-base font-semibold text-foreground">{title}</h3>
      {description && <p className="mt-1 max-w-md text-sm text-muted-foreground text-pretty">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export function ErrorAlert({ message, className }: { message: React.ReactNode; className?: string }) {
  if (!message) return null;
  return (
    <div
      className={cn(
        'rounded-md border border-destructive/30 bg-destructive/10 px-4 py-3 text-sm text-destructive',
        className
      )}
      role="alert"
    >
      {message}
    </div>
  );
}

export function InfoAlert({ message, className }: { message: React.ReactNode; className?: string }) {
  return (
    <div className={cn('rounded-md border border-info/30 bg-info/10 px-4 py-3 text-sm text-info', className)}>
      {message}
    </div>
  );
}

export function SuccessAlert({ message, className }: { message: React.ReactNode; className?: string }) {
  return (
    <div className={cn('rounded-md border border-success/30 bg-success/10 px-4 py-3 text-sm text-success', className)}>
      {message}
    </div>
  );
}

export function WarningAlert({ message, className }: { message: React.ReactNode; className?: string }) {
  return (
    <div className={cn('rounded-md border border-warning/30 bg-warning/10 px-4 py-3 text-sm text-warning', className)}>
      {message}
    </div>
  );
}
